import { render, staticRenderFns } from "./ScientificDrugName.vue?vue&type=template&id=398261fc&scoped=true"
import script from "./ScientificDrugName.vue?vue&type=script&lang=js"
export * from "./ScientificDrugName.vue?vue&type=script&lang=js"
import style0 from "./ScientificDrugName.vue?vue&type=style&index=0&id=398261fc&prod&scoped=true&lang=css"
import style1 from "./ScientificDrugName.vue?vue&type=style&index=1&id=398261fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398261fc",
  null
  
)

export default component.exports